import { Component, OnInit } from '@angular/core';
import { Errors } from "../../core/models/errors.module";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "../../core/services/auth.service";
import { CommonService } from "../../core/services/common.service";

@Component({
    selector: 'app-password-reset',
    templateUrl: './password-reset.component.html',
    styleUrls: ['./password-reset.component.css']
})
export class PasswordResetComponent implements OnInit {

    title: String = '';
    errors: Errors = new Errors();
    isSubmitting = false;
    authForm: FormGroup;
    token: null;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private authService: AuthService,
        private fb: FormBuilder,
        private commonService: CommonService
    ) {
        this.authForm = this.fb.group({
            'email': ['', Validators.required],
            'password': ['', Validators.required],
            'password_confirmation': ['', Validators.required],
            'token': ['']
        });
    }

    ngOnInit() {

        this.route.params.subscribe(params => {
            this.token = params['token'];
        });
        this.route.url.subscribe(data => {
            this.title = 'Reset Password';
        });
    }


    submitForm() {
        this.errors = new Errors();

        this.authForm.controls.token.setValue(this.token);

        this.authService
            .resetPassword(this.authForm.value).subscribe(
            response => {
                if (response['message'] == 'passwords.token') {
                    this.commonService.notifications.error('Error', 'Token Expired!')
                }
                else if (response['message'] == 'passwords.reset') {
                    this.commonService.notifications.success('Success', 'Password Reset Successfully');
                    this.router.navigateByUrl('/login')
                }
                else if (response['message'] == 'passwords.password') {
                    this.commonService.notifications.success('Error', 'Incorrect password, min 6 characters required');

                }
                else if (response['message'] == 'passwords.user') {
                    this.commonService.notifications.success('Error', 'No such User exist');

                }
                else {
                    this.commonService.notifications.error('Error', 'Something Went Wrong, Try again!')
                }
            }
        );
    }


    goToLogin() {
        this.router.navigateByUrl('/login');
    }

}




// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/login/password-reset/password-reset.component.ts